const t = "Étape terminée", e = "Retour à {buttonName}", n = "Continuer vers {buttonName}", o = {
  completedStep: t,
  backButton: e,
  nextButton: n
};
export {
  e as backButton,
  t as completedStep,
  o as default,
  n as nextButton
};
